import { render } from "./AutomaticRechargeView.vue?vue&type=template&id=4d4a8412&scoped=true"
import script from "./AutomaticRechargeView.vue?vue&type=script&lang=js"
export * from "./AutomaticRechargeView.vue?vue&type=script&lang=js"

import "./AutomaticRechargeView.vue?vue&type=style&index=0&id=4d4a8412&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4a8412"]])

export default __exports__